export default __webpack_public_path__ + "static/media/contorno_1.4419a867.jpg";